import { Search, RefreshCw, LogOut, Trash2 } from "lucide-react";
import { Button } from "./ui/button";
import NotificationsBell from "./NotificationsBell";

const AdminTopbar = ({
  sectionTitle,
  sectionDescription,
  onOpenSearch,
  onRefresh,
  onResetTestData,
  onLogout,
  notifications,
  unreadCount,
  onMarkAllRead,
  onMarkRead,
  onOpenAllNotifications,
  user,
}) => {
  const isMac = typeof navigator !== "undefined" && /mac/i.test(navigator.platform);
  return (
    <header className="h-16 bg-white border-b border-slate-200 flex items-center px-6 sticky top-0 z-10" data-testid="admin-topbar">
      {/* Title */}
      <div className="min-w-0">
        <h1 className="font-heading font-semibold text-lg text-slate-900 truncate">{sectionTitle}</h1>
        {sectionDescription && <p className="text-xs text-slate-500 truncate">{sectionDescription}</p>}
      </div>

      {/* Search (middle, pushes right-side to end) */}
      <div className="flex-1 flex justify-center px-6">
        <button
          type="button"
          onClick={onOpenSearch}
          className="w-full max-w-md flex items-center gap-2 px-3 py-2 text-sm text-slate-400 bg-slate-50 hover:bg-slate-100 border border-slate-200 rounded-md transition-colors"
          data-testid="open-global-search-btn"
        >
          <Search className="h-4 w-4 flex-shrink-0" />
          <span className="flex-1 text-left">Search orders, courses, inquiries...</span>
          <kbd className="hidden md:inline-flex items-center rounded border bg-white px-1.5 py-0.5 text-[10px] font-mono text-slate-500">
            {isMac ? "⌘K" : "Ctrl+K"}
          </kbd>
        </button>
      </div>

      {/* Right actions */}
      <div className="flex items-center gap-1">
        <NotificationsBell
          notifications={notifications}
          unreadCount={unreadCount}
          onMarkAllRead={onMarkAllRead}
          onMarkRead={onMarkRead}
          onOpenAll={onOpenAllNotifications}
        />
        <Button variant="ghost" size="icon" onClick={onRefresh} title="Refresh" data-testid="refresh-btn" className="h-9 w-9">
          <RefreshCw className="h-4 w-4" />
        </Button>
        <Button variant="ghost" size="icon" onClick={onResetTestData} title="Reset test data" className="h-9 w-9 text-orange-500 hover:text-orange-600 hover:bg-orange-50">
          <Trash2 className="h-4 w-4" />
        </Button>
        <div className="h-8 border-l border-slate-200 mx-2" />
        <div className="flex items-center gap-3 pl-1">
          <div className="hidden md:block text-right">
            <p className="text-sm font-medium leading-tight">{user?.username || "Admin"}</p>
            <p className="text-[10px] text-slate-500 leading-tight">Administrator</p>
          </div>
          <div className="w-8 h-8 rounded-full bg-brand text-white flex items-center justify-center font-semibold text-sm">
            {(user?.username || "A")[0].toUpperCase()}
          </div>
          <Button variant="ghost" size="icon" onClick={onLogout} title="Logout" className="h-9 w-9 text-slate-500 hover:text-red-600" data-testid="logout-btn">
            <LogOut className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </header>
  );
};

export default AdminTopbar;
